import '@web/shared-digital-library/icons/svg-originals/cross.svg';
import '@web/shared-digital-library/icons/svg-originals/logo.svg';
import CloseButton from '~/components/atoms/CloseButton.vue';
import MdmIcon from '~/components/atoms/Global/MdmIcon.vue';
export default {
  name: 'LayerFullscreen',
  components: {
    MdmIcon: MdmIcon,
    CloseButton: CloseButton
  }
};